// extracted by mini-css-extract-plugin
export default {"distributorUsageTable":"DistributorsUsageEntries_distributorUsageTable__y7fIa"};